import { Box, Divider, Skeleton } from '@mui/material';

export const EarningsSkeleton = () => {
  return (
    <Box sx={{ py: { xs: 1, sm: 2 } }}>
      {/* Calendar Header Skeleton */}
      <Box sx={{ textAlign: 'center', mb: 3, mt: 2 }}>
        <Skeleton
          variant="text"
          width={120}
          height={20}
          sx={{ mx: 'auto', mb: 1, bgcolor: 'action.hover' }}
        />
        <Skeleton
          variant="text"
          width={240}
          height={40}
          sx={{ mx: 'auto', bgcolor: 'action.hover' }}
        />
      </Box>

      {/* Date Navigation Skeleton */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          mb: 3,
        }}
      >
        <Skeleton variant="circular" width={32} height={32} sx={{ bgcolor: 'action.hover' }} />
        <Skeleton variant="text" width={120} height={24} sx={{ bgcolor: 'action.hover' }} />
        <Skeleton variant="circular" width={32} height={32} sx={{ bgcolor: 'action.hover' }} />
      </Box>

      {/* Mobile Content Skeleton (Visible only on mobile via CSS) */}
      <Box sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: 'column', gap: 3 }}>
        {[1, 2, 3].map((i) => (
          <Box key={i}>
            <Skeleton
              variant="text"
              width={100}
              height={24}
              sx={{ mb: 2, bgcolor: 'action.hover' }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {[1, 2].map((j) => (
                <Skeleton
                  key={j}
                  variant="rounded"
                  height={72}
                  sx={{ borderRadius: '8px', bgcolor: 'action.hover' }}
                />
              ))}
            </Box>
            {i < 3 && <Divider sx={{ my: 3 }} />}
          </Box>
        ))}
      </Box>

      {/* Desktop Content Skeleton (Visible only on desktop via CSS) */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          gap: 2,
          mb: 3,
          overflowX: 'hidden',
          alignItems: 'center',
        }}
      >
        <Skeleton
          variant="rounded"
          width={40}
          height={40}
          sx={{ flexShrink: 0, bgcolor: 'action.hover' }}
        />
        <Box sx={{ display: 'flex', gap: 2, flex: 1 }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              sx={{ flex: 1, height: 400, borderRadius: '12px', bgcolor: 'action.hover' }}
            />
          ))}
        </Box>
        <Skeleton
          variant="rounded"
          width={40}
          height={40}
          sx={{ flexShrink: 0, bgcolor: 'action.hover' }}
        />
      </Box>
    </Box>
  );
};
